<template>
  <div id="pers-tab2-5" name="hres32e-tab2-tab5">
    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC7']['20'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['40'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codtitle" 
                                :options="dropdowns.codtitle[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['41'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="namfirst" name="namfirst" 
                     maxlength="30"
                     v-model="detail.namfirst" 
                     v-validate="'max:30'"
                     data-vv-name="namfirst"
                     :has-error="errors.has('namfirst')" />
              <div class="text-error" v-show="errors.has('namfirst')">{{errors.first('namfirst')}}</div>
            </div>
          </div>   
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['42'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="namlast" name="namlast" 
                     maxlength="30"
                     v-model="detail.namlast" 
                     v-validate="'max:30'"
                     data-vv-name="namlast"
                     :has-error="errors.has('namlast')" />
              <div class="text-error" v-show="errors.has('namlast')">{{errors.first('namlast')}}</div>
            </div>
          </div>   
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['50'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="numspid" name="numspid" 
                     v-model="detail.numspid" 
                     maxlength="13"
                     v-validate="'max:13'"
                     data-vv-name="numspid"
                     :has-error="errors.has('numspid')" />
              <div class="text-error" v-show="errors.has('numspid')">{{errors.first('numspid')}}</div>
            </div>
          </div>  
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['60'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dtespbd"
                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                  data-vv-value-path="inputDate"
                                  name="dtespbd"
                                  :has-error="errors.has('dtespbd')" 
                                  style="margin-bottom:5px;"/>
                <div class="text-error" v-show="errors.has('dtespbd')">{{errors.first('dtespbd')}}</div>  
            </div>
          </div> 
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['70'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codspocc" 
                                :options="dropdowns.codfoccu[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>   
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['80'] }}</div>
            <div class="col-xs-7 data-input">
                <textarea class="form-control textarea-text" id="desnoffi" name="desnoffi" 
                          v-model="detail.desnoffi" 
                          maxlength="50"
                          v-validate="'max:50'"
                          data-vv-name="desnoffi"
                          :has-error="errors.has('desnoffi')" ></textarea>
                <div class="text-error" v-show="errors.has('desnoffi')">{{errors.first('desnoffi')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(50) }}</div> 
            </div>
          </div>    
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12  card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRES32EC7']['30'] }}</div>
        </div>
        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['90'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-datepicker  v-model="detail.dtemarry"
                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                  data-vv-value-path="inputDate"
                                  name="dtemarry"
                                  :has-error="errors.has('dtemarry')"
                                  style="margin-bottom:5px;" />
                <div class="text-error" v-show="errors.has('dtemarry')">{{errors.first('dtemarry')}}</div>  
            </div>
          </div>
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['100'] }}</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" id="desplreg" name="desplreg" 
                     v-model="detail.desplreg" 
                     maxlength="20"
                     v-validate="'max:20'"
                     data-vv-name="desplreg"
                     :has-error="errors.has('desplreg')" />
              <div class="text-error" v-show="errors.has('desplreg')">{{errors.first('desplreg')}}</div>
            </div>
          </div> 
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['110'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codsppro" 
                                :options="dropdowns.codprovr[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['120'] }}</div>
            <div class="col-xs-7 data-input">
                <hrms-dropdown  v-model="detail.codspcty" 
                                :options="dropdowns.codcount[nowLang]" 
                                style="margin-bottom:5px;"/>
            </div>
          </div>      
          <div class="data-row">
            <div class="col-xs-5 data-label">{{ labels['HRES32EC7']['130'] }}</div>
            <div class="col-xs-7 data-input">
                <textarea class="form-control textarea-text" id="desnote" name="desnote" 
                          v-model="detail.desnote" 
                          maxlength="50"
                          v-validate="'max:50'"
                          data-vv-name="desnote"
                          :has-error="errors.has('desnote')" ></textarea>
                <div class="text-error" v-show="errors.has('desnote')">{{errors.first('desnote')}}</div> 
                <div class="remark-limit-character">{{ dispLimitLabel(50) }}</div> 
            </div>
          </div> 
        </div>
      </div>
    </div>
    
    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres32e-tab2-tab5',
  data () {
    return {
      subTopic1: true,
      subTopic2: true
    }
  },
  watch: {
    'detail.namfirst' () {
      this.$validator.validate('namfirst', this.detail.namfirst).catch(e => {})
    },
    'detail.namlast' () {
      this.$validator.validate('namlast', this.detail.namlast).catch(e => {})
    },
    'detail.numspid' () {
      this.$validator.validate('numspid', this.detail.numspid).catch(e => {})
    },
    'detail.desnoffi' () {
      this.$validator.validate('desnoffi', this.detail.desnoffi).catch(e => {})
    },
    'detail.desplreg' () {
      this.$validator.validate('desplreg', this.detail.desplreg).catch(e => {})
    },
    'detail.desnote' () {
      this.$validator.validate('desnote', this.detail.desnote).catch(e => {})
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    saveParams () {
      return {
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq,
        // n_namspous: this.detail.namspous,
        n_codtitle: this.detail.codtitle,
        n_namfirst: this.detail.namfirst,
        n_namlast: this.detail.namlast,
        n_numspid: this.detail.numspid,
        n_dtespbd: this.detail.dtespbd,
        // n_dtespbd: moment().format('DD/MM/YYYY').replace(/\//g, ''),
        n_codspocc: this.detail.codspocc,
        n_desnoffi: this.detail.desnoffi,
        n_dtemarry: this.detail.dtemarry,
        // n_dtemarry: moment().format('DD/MM/YYYY').replace(/\//g, ''),
        n_desplreg: this.detail.desplreg,
        n_codsppro: this.detail.codsppro,
        n_codspcty: this.detail.codspcty,
        n_desnote: this.detail.desnote
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postDetail2Tab5Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'indexSelected', 'pcDisp', 'togglePage', 'toggleSubPage', 'triggerSubButton', 'labelsButton', 'dropdowns', 'postDetail2Tab5Save', 'searchIndex', 'validateStaappr' ]
}

</script>


// WEBPACK FOOTER //
// tab2_5.vue?2fe61278